import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MessageSquare, Loader2 } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuth";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username.trim(), password);
      toast.success("Вхід виконано");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#0F76BC]/10 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#0F76BC]/5 blur-3xl" />
      </div>
      <div className="relative w-full max-w-md bg-white rounded-[12px] border border-slate-200 shadow-[0_8px_32px_rgba(15,118,188,0.12)] p-8">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-11 h-11 rounded-[12px] bg-[#0F76BC] flex items-center justify-center text-white">
            <MessageSquare size={22} />
          </div>
          <div>
            <div className="font-head font-extrabold text-lg leading-tight">IPPLUS CRM</div>
            <div className="text-xs text-slate-500">Панель провайдера</div>
          </div>
        </div>
        <h1 className="font-head text-2xl font-bold mt-6 mb-6 tracking-tight">Вхід в панель управління</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-600 mb-1.5 block">Логін</label>
            <input
              data-testid="login-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              className="w-full border border-slate-200 rounded-[12px] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0F76BC]/20 focus:border-[#0F76BC] transition-[border-color,box-shadow] bg-white"
              placeholder="Ваш логін"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600 mb-1.5 block">Пароль</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full border border-slate-200 rounded-[12px] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0F76BC]/20 focus:border-[#0F76BC] transition-[border-color,box-shadow] bg-white"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full bg-[#0F76BC] hover:bg-[#0c5f96] text-white px-6 py-3 rounded-[12px] font-semibold transition-[background-color,transform] active:scale-[0.98] shadow-sm flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {busy && <Loader2 size={18} className="animate-spin" />}
            Увійти
          </button>
        </form>
      </div>
    </div>
  );
}
